import React, { useContext, useState } from "react";
import { ListActionButtonProps } from "sprint-common-web";

import { EditListButton } from "../../../../../common/components/buttons/EditListButton";
import { DistributorsDataProvider } from "../../../../../common/data/lookup-data-providers/DistributorsDataProvider";
import { MovieVersionListingContext } from "../context/MovieVersionListingContext";
import { EditMovieVersionAside } from "../edit-version-form/EditMovieVersionAside";
import { UpdatedVersionData } from "../edit-version-form/EditMovieVersionForm";
import { MovieVersionListingItem } from "../MovieVersionListingItem";

export const EditVersionButton: React.FunctionComponent<ListActionButtonProps> = (props: ListActionButtonProps) => {
    const { listingItems, versionsToMerge, updateMovieVersion } = useContext(MovieVersionListingContext);
    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);

    const handleClick = (event?: React.MouseEvent<HTMLButtonElement>) => {
        event?.currentTarget.blur();

        setIsAsideOpen(true);

        if (props.onClick) {
            props.onClick();
        }
    };

    const isButtonDisabled = (): boolean => {
        if (versionsToMergeContainItemId(versionsToMerge, props.itemId)) {
            return true;
        }

        if (listingItemMerged(listingItems, props.itemId)) {
            return true;
        }

        return false;
    };

    const handleEditVersionFormSubmit = (updatedVersionData: UpdatedVersionData) => {
        updateMovieVersion(updatedVersionData);
        setIsAsideOpen(false);
    };

    const closeEditVersionSidebar = () => {
        setIsAsideOpen(false);
    };

    const buttonDisabled = props.disabled || isButtonDisabled();

    return (
        <DistributorsDataProvider>
            <EditListButton disabled={buttonDisabled} onClick={handleClick} />
            <EditMovieVersionAside
                onSubmit={handleEditVersionFormSubmit}
                onClose={closeEditVersionSidebar}
                isOpen={isAsideOpen}
                defaultItemId={props.itemId ?? ""}
            />
        </DistributorsDataProvider>
    );
};

const versionsToMergeContainItemId = (versionsToMerge: MovieVersionListingItem[], actualItemId?: string) => {
    return versionsToMerge.some((version: MovieVersionListingItem) => version.id === actualItemId);
};

const listingItemMerged = (listing: MovieVersionListingItem[], itemId?: string) => {
    return listing.some((version: MovieVersionListingItem) => version.id === itemId && version.merged);
};
